import React from 'react';
import styled from 'styled-components';

import type { WorkArtistData } from '../../shared/dto/EntityRepository';
import { WorkContentMode } from '../../shared/enum/EnumRepository';
import { useWorkContentModeStore } from '../../shared/store/workContentModeStore';
import { useWorkPropertyVisibleStore } from '../../shared/store/workPropertyVisibleStore';
import { useSettingStore } from '../../shared/store/settingStore';
import { resolveWorkArtistName, shouldShowWorkArtist } from '../../shared/util/workArtist';
import { shrinkString } from '../../shared/util/shrinkString';

interface WorkArtistListLineProps {
  artist: WorkArtistData | null | undefined;
  maxLength?: number;
  mode?: WorkContentMode;
}

const WorkArtistListLine: React.FC<WorkArtistListLineProps> = ({
  artist,
  maxLength = 35,
  mode,
}) => {
  const setting = useSettingStore((state) => state.setting);
  const workContentMode = useWorkContentModeStore((state) => state.workContentMode);
  const engVisible = useWorkPropertyVisibleStore(
    (state) => state.workPropertyVisible?.engVisible !== false,
  );

  if (!shouldShowWorkArtist(setting)) return null;
  const name = resolveWorkArtistName(artist, mode ?? workContentMode, engVisible);
  if (!name) return null;

  return <ArtistLine>{shrinkString(name, maxLength)}</ArtistLine>;
};

export default WorkArtistListLine;

const ArtistLine = styled.span`
  width: 100%;
  overflow: hidden;
  color: ${({ theme }) => theme.colors.color_Gray_05};
  text-overflow: ellipsis;
  white-space: nowrap;
  ${({ theme }) => theme.typography.Footer_02};
`;
